const config = {
  paginationStartIndex: 1,
};

export const RISK_TYPES = 58;
export const RISK_CATEGORIES = 6;

export default config;
